import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 保存JP24反恐舱单地址
export function saveAfrAddress(data) {
  return request({
    url: URL.booking.saveAfrAddress,
    method: 'post',
    data
  })
}
